import {
  dispatchSiteEvent,
  siteEventNames,
} from '../events/site-events';
import { getOptimizelyExperimentationString } from './optimizely-experimentation-utils';
import { isEmptyString } from './string-utils';


const isCustomFieldChecked = (form, name) => (
  [...getElementByCustomFieldName(form, name)].filter(item => item.checked).length > 0
);

const getElementByCustomFieldName = (form, name) => (
  form.querySelectorAll(`[data-mailchimp="${name}"]`)
);

const getMultipleCheckedValsByCustomFieldName = (form, name) => (
  [...getElementByCustomFieldName(form, name)]
    .filter(item => item.checked)
    .map(item => item.value)
    .join(',')
);

const getValByCustomFieldName = (form, name) => (
  [...getElementByCustomFieldName(form, name)]
    .map(item => item.value)
    .join(',')
);

const subscribeLead = (options) => {
  if (options === null || options.form === null) {
    return;
  }
  const { form } = options;
  const getValue = (name) => (getValByCustomFieldName(form, name) );
  // Get timestamp if required for Dealer interest
  const date = '';
  // Detect whether new/old INTEREST_DEALER by length;
  let dealerOptin = false;
  if (getElementByCustomFieldName(form, 'INTEREST_DEALER').length > 1) {
    // *NEW* Radio group, get selected value
    var selectedVal = getMultipleCheckedValsByCustomFieldName(form, 'INTEREST_DEALER');
    if (selectedVal.indexOf('yes') != -1) {
      dealerOptin = true;
    }
    dealerOptin = getMultipleCheckedValsByCustomFieldName(form, 'INTEREST_DEALER');
  } else {
    dealerOptin = isCustomFieldChecked(form, 'INTEREST_DEALER');
  }
  const tags = getValue('DRIP_TAGS').split(',');
  // Add brand opt-in tag
  if (isCustomFieldChecked(form, 'INTEREST_BRAND')) {
    tags.push('Opted In');
  }
  // Add dealer opt-in tag
  if (dealerOptin) {
    tags.push('Consumer Lead to Pickup');
  }
  var interests = '';
  // If product page
  if (window.productLineInterestName) {
    interests = window.productLineInterestName;
  }
  // If find a dealer
  var interestInputValues = getMultipleCheckedValsByCustomFieldName(form, 'PRODUCT_INTERESTS');
  if (interestInputValues != '') {
    interests = interestInputValues;
  }
  // Switch visualization campaigns
  var campaign = getValue('CAMPAIGN');
  if (getMultipleCheckedValsByCustomFieldName(form, 'VIZ_KEY') !== '') {
    campaign = getValue('CAMPAIGN_WITH_VISUALIZATION')
  }
  // Get Google Click Id (if exists for the form)
  let currentDate = new Date();
  // New Dealer Sampling page - Check if the form has an ide of #new-dealer-sampling-form. If so, the form will submit additional values from that form for drip
  let newDealerSampling = (document.querySelector('#new-dealer-sampling-form')) ? true : false;
  let { userID, utmCampaign, utmContent, utmMedium, utmSource, utmTerm } = window.dataLayer[0];
  let optimizelyExperiments = getOptimizelyExperimentationString();
  // Drip Call
  _dcq.push(
    [
      'identify',
      {
        email: getValue('EMAIL'),
        first_name: getValue('FNAME'),
        last_name: getValue('LNAME'),
        phone: getValue('PHONE'),
        address1: getValue('ADDR_LINE1'),
        address2: getValue('ADDR_LINE2'),
        city: getValue('ADDR_CITY'),
        state: getValue('ADDR_STATE'),
        zip: getValue('ADDR_ZIP'),
        country: getValue('ADDR_CNTRY'),
        source: getValue('SOURCE'),
        gclid: getValue('GCLID'),
        design_studio_id: getValue('DESIGN_STUDIO_ID'),
        visualizer_source: getValue('VISUALIZER_SOURCE'),
        d_opt_in: date,
        viz_key: getMultipleCheckedValsByCustomFieldName(form, 'VIZ_KEY'),
        campaign,
        product_interests: interests,
        page_submitted_from: window.location.href,
        tags: tags,
        last_form_submitted_date: currentDate,
        user_id: userID,
        ...(isEmptyString(utmCampaign) && { utm_campaign: utmCampaign }),
        ...(isEmptyString(utmContent) && { utm_content: utmContent }),
        ...(isEmptyString(utmMedium) && { utm_medium: utmMedium }),
        ...(isEmptyString(utmSource) && { utm_source: utmSource }),
        ...(isEmptyString(utmTerm) && { utm_term: utmTerm }),
        ...(isEmptyString(optimizelyExperiments) && { optimizely_experiments: optimizelyExperiments }),
        ...(newDealerSampling && { selected_bundle: getValue('SELECTED_BUNDLE') }),
        ...(newDealerSampling && { store_number: getValue('STORE_NUMBER')}),
        ...(newDealerSampling && { company_number: getValue('COMPANY_NUMBER') }),
        ...(newDealerSampling && { company_name: getValue('COMPANY_NAME') }),
        ...(newDealerSampling && { company_contact: getValue('COMPANY_CONTACT') }),
        ...(newDealerSampling && { who_is_your_graber_tsm: getValue('WHO_IS_YOUR_GRABER_TSM') }),
        success: function(data) {
          // console.log(data);
          if (options !== undefined) {
            if (options.success !== undefined) {
              options.success(data);
            }
          }
        },
        failure: function(data) {
          // console.log(data);
          if (options !== undefined) {
            if (options.fail !== undefined) {
              options.fail(data);
            }
          }
        },
      },
    ]
  );
  // GTM Call
  dispatchSiteEvent(siteEventNames.ON_FORM_SUBMIT_SUCCESS, {
    optin: isCustomFieldChecked(form, 'INTEREST_BRAND'),
  });
};

export {
  isCustomFieldChecked,
  getElementByCustomFieldName,
  getMultipleCheckedValsByCustomFieldName,
  getValByCustomFieldName,
  subscribeLead,
};
